// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay___kd1_","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__206dw"};